import script from "./Connection.vue?vue&type=script&setup=true&lang=ts"
export * from "./Connection.vue?vue&type=script&setup=true&lang=ts"

import "./Connection.vue?vue&type=style&index=0&id=631e5da5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-631e5da5"]])

export default __exports__